import css from './submit-setlist.module.scss';
import {Button} from '../button/button';
import {useNavigate} from '@tanstack/react-location';

export const SubmitSetlist = (): JSX.Element => {
	const navigate = useNavigate();

	const onSubmit = () => {
		navigate({to: '/register'});
	};

	const onBack = () => {
		navigate({to: '/event-detail'});
	};

	return (
		<div className={css.container}>
			<p className={css.text}>Tap on songs to edit submission or drag to reorder the setlist, otherwise tap Submit.</p>
			<div className={css.buttonsContainer}>
				<a onClick={onBack} className={css.backButton}>
					Back
				</a>
				<Button onClick={onSubmit} icon="/img/checkIconWhite.svg" name="Submit" color="blue" />
			</div>
		</div>
	);
};
